import * as environment from '../environment'

import { get, post, getHeaders } from './common'

export async function getInfo() {
    const headers = getHeaders(true);

    return get(
        `${environment.default.gatewayBaseUrl}/user/info`,
        headers
    );
}

export async function contactSupport(data) {
    const headers = getHeaders(true);

    return post(
        `${environment.default.gatewayBaseUrl}/user/contact-support`,
        data,
        headers
    );
}
